/**
 * MuiLink
 */
const MuiLink = {
  defaultProps: {
    underline: 'hover'
  }
};
export default MuiLink;